/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';

@Component({
  selector: 'ngx-app',
  template: `
    <app-loader></app-loader>
  <router-outlet></router-outlet>
  `,
})
export class AppComponent implements OnInit {

  constructor(private analytics: AnalyticsService, private seoService: SeoService,
              private translate: TranslateService) {
    this.translate.setDefaultLang('en');
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    // console.log("language -> ", JSON.parse(localStorage.getItem('restrictedUserMenu')));
    // if(JSON.parse(localStorage.getItem('restrictedUserMenu')) === "91e64499-2811-410a-98fb-dc8ac6a5d75b"){
    //   this.translate.use('pl');
    // } else {
    //   this.translate.use('en');
    // }
  }
}
